<template>
  <div id="data-list-list-view" class="data-list-container">
    <div v-if="initProgress" class="w-100 mt-5 mb-5">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>

    <vs-prompt title="Exportar a Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel"
               accept-text="Exportar" cancel-text="Cancelar" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" placeholder="Ingresa el nombre del archivo..." class="w-full"/>
      <v-select v-model="selectedFormat" :options="formats" class="my-4"/>
      <div class="flex">
        <span class="mr-4">Auto ajustar columna:</span>
        <vs-switch v-model="cellAutoWidth">Auto ajustar columna</vs-switch>
      </div>
    </vs-prompt>

    <vx-card v-if="filter" ref="filterCard" title="Filtros" class="user-list-filters mb-8" collapse-action
             refresh-content-action @refresh="resetFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Filtrar por categoría</label>
          <v-select label="name" :options="categories" :clearable="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="categoryFilter" class="mb-4 md:mb-0"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Filtrar por stock</label>
          <v-select :options="stocksOptions" :clearable="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="stockFilter" class="mb-4 md:mb-0"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Filtrar por tipo</label>
          <v-select :options="topFilters" :clearable="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="topFilter" class="mb-4 md:mb-0"/>
        </div>
      </div>
    </vx-card>

    <new :list-for-related-products="listForRelatedProducts"
         :colors="colors"
         :categories="categories"
         :occasions="occasions"
         :flowers="flowers"
         :properties="properties"
         :vases="vases"
         :isSidebarActive="newSidebar"
         @closeSidebar="toggleNewSidebar"
         @add="addDataSideBar"
         :data="sidebarData"/>
    <update :list-for-related-products="listForRelatedProducts"
            :colors="colors"
            :categories="categories"
            :occasions="occasions"
            :flowers="flowers"
            :properties="properties"
            :vases="vases"
            :productsAll="productsAll" :isSidebarActive="updateSidebar"
            @closeSidebar="toggleUpdateSidebar"
            @update="updateDataSideBar"
            :data="sidebarData"/>
    <sizes :isSidebarActive="sizeSidebar"
           @closeSidebar="toggleSizeSidebar"
           :data="sidebarData"/>

    <vs-table v-model="selected" ref="table" pagination :max-items="itemsPerPage" search
              :data="list">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- Action - dropnow -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Acciones</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="editData(selected)">
                <span class="flex items-center">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Editar</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="filterData">
                <span class="flex items-center">
                  <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Filtrar</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="activePrompt = true">
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Exportar</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="exportToExcelFB">
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Exportar FB</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="exportToExcelGM">
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Exportar GM</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="$router.push({name: 'products-import'})">
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Actualizar precios</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!-- Add new -->
          <vs-button :disabled="initProgress" color="danger" type="border" class="mr-6" @click="addNewData">
            Agregar
          </vs-button>
          <!-- End -->
          <!-- Save -->
          <vs-button v-if="showOrder" type="border" class="mr-6" @click="saveOrder">
            Guardar
          </vs-button>
          <!-- End -->
        </div>

        <!-- Items per page -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
              currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{ list.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : list.length }} de {{
              queriedItems
              }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th v-if="showOrder" sort-key="order">Order</vs-th>
        <vs-th sort-key="sku">SKU</vs-th>
        <vs-th sort-key="name">Nombre</vs-th>
        <vs-th sort-key="category">Categoría</vs-th>
        <vs-th sort-key="stock">Stock</vs-th>
        <vs-th sort-key="normalPrice">Precio Normal</vs-th>
        <vs-th sort-key="priceDiscount">Precio Dcto.</vs-th>
        <vs-th>Estado</vs-th>
        <vs-th>En Stock</vs-th>
        <vs-th sort-key="stockControl">Control de Stock</vs-th>
        <vs-th>Destacado</vs-th>
        <vs-th>Oferta</vs-th>
        <vs-th>+ Vendido</vs-th>
        <vs-th>Día sig.</vs-th>
        <vs-th>Acciones</vs-th>
      </template>

      <template slot-scope=" {data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td v-if="showOrder">
              <vs-input v-model.number="tr[topFilter.value + 'Order']" type="number"></vs-input>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.sku }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.category ? tr.category.name : 'NN' }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.stock }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.normalPrice }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.priceDiscount }}</p>
            </vs-td>

            <vs-td>
              <vs-switch @input="switchState(tr)" v-model="tr.state"/>
            </vs-td>

            <vs-td>
              <vs-switch @input="switchStockAvailable(tr)" v-model="tr.stockAvailable"/>
            </vs-td>
            <vs-td>
              <vs-switch @input="switchStockControl(tr)" v-model="tr.stockControl"/>
            </vs-td>

            <vs-td>
              <vs-switch @input="switchFeatured(tr)" v-model="tr.featured"/>
            </vs-td>

            <vs-td>
              <vs-switch @input="switchOffer(tr)" v-model="tr.offer"/>
            </vs-td>

            <vs-td>
              <vs-switch @input="switchBestSeller(tr)" v-model="tr.best"/>
            </vs-td>

            <vs-td>
              <vs-switch @input="switchNextDayOnly(tr)" v-model="tr.nextDayOnly"/>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            @click.stop="editData(tr)"/>
              <feather-icon class="ml-2" icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            @click.stop="viewProduct(tr)"/>
              <feather-icon class="ml-2" icon="ScissorsIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            @click.stop="addSize(tr)"/>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import New from './New'
import Update from './Update'
import Sizes from './Sizes'
import vSelect from 'vue-select'

import { db, FieldValue } from '@/firebase/firebaseConfig'

export default {
  name: 'ListProducts',
  components: {
    New,
    Update,
    vSelect,
    Sizes
  },
  data() {
    return {
      itemsPerPage: 20,
      isMounted: false,
      list: [],
      productsAll: [],
      listForRelatedProducts: [],
      initProgress: false,
      selected: null,
      filter: false,
      //Filters
      categories: [],
      occasions: [],
      flowers: [],
      properties: [],
      vases: [],
      colors: [],
      stocksOptions: [
        { label: 'Todos', value: -1 },
        { label: 'Sin stock', value: 0 },
        { label: 'Por acabarse', value: 10 },
      ],
      topFilters: [
        {
          label: 'Destacados',
          value: 'featured'
        },
        { label: 'Ofertas', value: 'offer' },
        { label: 'Más vendidos', value: 'best' },
        {
          label: 'Promociones',
          value: 'isPriceDifferent'
        },
      ],
      categoryFilter: {
        label: 'Todos',
        value: -1
      },
      stockFilter: {
        label: 'Todos',
        value: -1
      },
      topFilter: {},
      showOrder: false,
      //

      // Data Sidebar
      newSidebar: false,
      updateSidebar: false,
      sizeSidebar: false,
      sidebarData: {},
      // Export
      fileName: '',
      formats: ['xlsx', 'csv', 'txt'],
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      headerTitle: ['ID', 'Nombre', 'Categoría', 'SKU', 'Stock', 'Precio normal', 'Precio con descuento', 'Estado'],
      headerVal: ['id', 'name', 'category', 'sku', 'stock', 'normalPrice', 'priceDiscount', 'state'],
      activePrompt: false,
      // Migration
    }
  },
  async created() {
    try {
      this.initProgress = true
      await this.loadProducts()
      await this.loadCategories()
      await this.loadOccasions()
      await this.loadFlowers()
      await this.loadProperties()
      await this.loadVases()
      await this.loadColors()
      this.initProgress = false
    } catch (e) {
      console.log(e)
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error.'
      })
    } finally {
      this.initProgress = false
    }
  },
  mounted() {
    this.isMounted = true
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.list.length
    }
  },
  watch: {
    /**
     * Filter by category
     * @param val
     * @returns {Promise<void>}
     */
    async categoryFilter(val) {
      try {
        if (val.value !== -1) {
          this.initProgress = true
          this.showOrder = false
          this.list = []
          const querySnapshot = await db.collection('products')
            .where('category.id', '==', this.categoryFilter.id)
            .orderBy('createdAt', 'desc').get()

          querySnapshot.forEach((doc) => {
            let product = {
              id: doc.id,
              ...doc.data()
            }
            this.list.push(product)
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    },
    /**
     * Filter by stock
     * @param val
     * @returns {Promise<void>}
     */
    async stockFilter(val) {
      try {
        if (val.value !== -1) {
          this.initProgress = true
          this.showOrder = false
          this.list = []
          const querySnapshot = await db.collection('products')
            .where('stock', '<=', this.stockFilter.value).get()

          querySnapshot.forEach((doc) => {
            let product = {
              id: doc.id,
              ...doc.data()
            }
            this.list.push(product)
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    },
    /**
     * Filter by stock
     * @param val
     * @returns {Promise<void>}
     */
    async topFilter(val) {
      try {
        if (val.value) {
          this.initProgress = true
          this.showOrder = true
          this.list = []

          const querySnapshot = await db.collection('products')
            .where(val.value, '==', true).get()

          let index = 1
          querySnapshot.forEach((doc) => {
            let product = {
              id: doc.id,
              ...doc.data(),
              offerOrder: doc.data().offerOrder || 0,
              featuredOrder: doc.data().featuredOrder || 0,
              bestOrder: doc.data().bestOrder || 0,
              isPriceDifferentOrder: doc.data().isPriceDifferentOrder || (index)
            }
            delete product.createdAt
            delete product.updatedAt

            index++
            this.list.push(product)
          })
        }
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    }
  },
  methods: {
    /**
     * Rewrites Cloudflare Images URLs of products in Firestore so every
     * `image1..image16` field uses the `1080x1350` variant. URLs that already
     * use that variant — and any non-Cloudflare URLs — are left untouched.
     */
    addNewData() {
      this.sidebarData = {}
      this.newSidebar = true
    },
    editData(data) {
      if (data) {
        this.sidebarData = data
        this.toggleUpdateSidebar(true)
      }
    },
    addSize(data) {
      if (data) {
        this.sidebarData = data
        this.toggleSizeSidebar(true)
      }
    },
    filterData() {
      this.filter = !this.filter
    },
    toggleNewSidebar(val = false) {
      this.newSidebar = val
    },
    toggleUpdateSidebar(val = false) {
      this.updateSidebar = val
    },
    toggleSizeSidebar(val = false) {
      this.sizeSidebar = val
    },
    /**
     * Enable or disabled
     * @param product
     */
    async switchState(product) {
      try {
        let productRef = await db.collection('products').doc(product.id)
        productRef.update({
          state: product.state
        })
        this.$vs.notify({
          color: 'success',
          title: 'Producto',
          text: 'La modificación fue aplicada.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    /**
     * Stock available
     * @param product
     */
    async switchStockAvailable(product) {
      try {
        let productRef = await db.collection('products').doc(product.id)
        productRef.update({
          stockAvailable: product.stockAvailable
        })
        this.$vs.notify({
          color: 'success',
          title: 'Producto',
          text: 'La modificación fue aplicada.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    /**
     * Stock control
     * @param product
     */
    async switchStockControl(product) {
      try {
        let productRef = await db.collection('products').doc(product.id)
        productRef.update({
          stockControl: product.stockControl
        })
        this.$vs.notify({
          color: 'success',
          title: 'Producto',
          text: 'La modificación fue aplicada.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    /**
     * Featured product
     * @param product
     */
    async switchFeatured(product) {
      try {
        let productRef = await db.collection('products').doc(product.id)
        productRef.update({
          featured: product.featured
        })
        this.$vs.notify({
          color: 'success',
          title: 'Producto',
          text: 'La modificación fue aplicada.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    /**
     * Offer product
     * @param product
     */
    async switchOffer(product) {
      try {
        let productRef = await db.collection('products').doc(product.id)
        productRef.update({
          offer: product.offer
        })
        this.$vs.notify({
          color: 'success',
          title: 'Producto',
          text: 'La modificación fue aplicada.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    /**
     * Offer product
     * @param product
     */
    async switchBestSeller(product) {
      try {
        let productRef = await db.collection('products').doc(product.id)
        productRef.update({
          best: product.best
        })
        this.$vs.notify({
          color: 'success',
          title: 'Producto',
          text: 'La modificación fue aplicada.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    async switchNextDayOnly(product) {
      try {
        let productRef = await db.collection('products').doc(product.id)
        productRef.update({
          nextDayOnly: product.nextDayOnly
        })
        this.$vs.notify({
          color: 'success',
          title: 'Producto',
          text: 'La modificación fue aplicada.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    /**
     * Get products of firestore
     * @returns {Promise<void>}
     */
    async loadProducts() {
      const querySnapshot = await db.collection('products')
        .orderBy('createdAt', 'desc')
        .get()
      querySnapshot.forEach((doc) => {
        let product = {
          id: doc.id,
          ...doc.data(),
          featured: doc.data().featured || false,
          offer: doc.data().offer || false,
          best: doc.data().best || false,
          nextDayOnly: doc.data().nextDayOnly || false,
        }
        if (product.newProduct === undefined) {
          product.newProduct = false
        }
        this.list.push(product)
        this.listForRelatedProducts.push({
          id: doc.id,
          slug: doc.data().slug,
          name: doc.data().name + '-' + doc.data().sku,
          featured: doc.data().featured || false,
          offer: doc.data().offer || false,
          best: doc.data().best || false
        })
      })
    },
    /**
     * Get categories of firestore
     * @returns {Promise<void>}
     */
    async loadCategories() {
      const querySnapshot = await db.collection('categories').orderBy('createdAt', 'desc').get()
      querySnapshot.forEach((doc) => {
        let category = {
          id: doc.id,
          name: doc.data().name,
          slug: doc.data().slug,
          image: doc.data().image
        }
        this.categories.push(category)
      })
    },
    /**
     * Get categories of firestore
     * @returns {Promise<void>}
     */
    async loadOccasions() {
      const querySnapshot = await db.collection('occasions').orderBy('createdAt', 'desc').get()
      querySnapshot.forEach((doc) => {
        let occasion = {
          id: doc.id,
          name: doc.data().name,
          slug: doc.data().slug,
          image: doc.data().image
        }
        this.occasions.push(occasion)
      })
    },
    /**
     * Get colors of firestore
     * @returns {Promise<void>}
     */
    async loadFlowers() {
      const querySnapshot = await db.collection('flowers').orderBy('createdAt', 'desc').get()
      querySnapshot.forEach((doc) => {
        let flower = {
          id: doc.id,
          name: doc.data().name,
          slug: doc.data().slug,
          image: doc.data().image
        }
        this.flowers.push(flower)
      })
    },
    async loadProperties() {
      const querySnapshot = await db.collection('properties').orderBy('createdAt', 'desc').get()
      querySnapshot.forEach((doc) => {
        let property = {
          id: doc.id,
          name: doc.data().name,
          image: doc.data().image
        }
        this.properties.push(property)
      })
    },
    async loadVases() {
      const querySnapshot = await db.collection('vases').orderBy('createdAt', 'desc').get()
      querySnapshot.forEach((doc) => {
        if (doc.data().state) {
          this.vases.push({
            id: doc.id,
            name: doc.data().name,
            image: doc.data().image,
            price: doc.data().price
          })
        }
      })
    },
    async loadColors() {
      const querySnapShot = await db.collection('colors').orderBy('createdAt', 'desc').get()
      querySnapShot.forEach((doc) => {
        let color = {
          id: doc.id,
          name: doc.data().name,
          hex: doc.data().hex
        }
        this.colors.push(color)
      })
    },
    /**
     * Reset filters
     * @returns {Promise<void>}
     */
    async resetFilters() {
      try {
        this.initProgress = true
        this.showOrder = false
        await this.loadProducts()

        this.categoryFilter = {
          label: 'Todos',
          value: -1
        }
        this.stockFilter = {
          label: 'Todos',
          value: -1
        }
        this.topFilter = {}

        this.$refs.filterCard.removeRefreshAnimation()
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    },
    exportToExcel() {
      import('@/vendor/Export2Excel').then(excel => {
        const list = []
        this.list.forEach((p) => {
          let product = {
            id: p.id,
            name: p.name,
            sku: p.sku,
            stock: p.stock,
            priceDiscount: p.priceDiscount + '',
            normalPrice: p.normalPrice + '',
            state: p.state,
            category: p.category.name
          }
          list.push(product)
        })
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    exportToExcelFB() {
      import('@/vendor/Export2Excel').then(async excel => {
        this.initProgress = true
        const list = []
        for await (let p of this.list) {
          const querySnapshot = await db.collection('products').doc(p.id).collection('sizes').get()
          if (querySnapshot.size !== 0) {
            querySnapshot.forEach((doc) => {
              let product = {
                id: p.sku + '-' + doc.data().size,
                title: p.name,
                description: p.description,
                availability: doc.data().stock > 0 ? 'in stock' : 'out of stock',
                condition: 'new',
                price: p.normalPrice + ' PEN',
                link: 'http://lacamelia.pe/products/first/' + p.slug,
                image_link: p.image3 || p.image1,
                additional_image_link: p.image4,
                brand: 'La Camelia',
                sale_price: p.priceDiscount + ' PEN',
                visibility: p.state ? 'visibility' : 'hidden',
                size: doc.data().size,
                item_group_id: p.sku
              }
              list.push(product)
            })
          }
        }
        const headerVal = ['id', 'title', 'description', 'availability', 'condition', 'price', 'link', 'image_link', 'brand', 'sale_price', 'visibility', 'additional_image_link', 'size', 'item_group_id']
        const headerTitle = ['id', 'title', 'description', 'availability', 'condition', 'price', 'link', 'image_link', 'brand', 'sale_price', 'visibility', 'additional_image_link', 'size', 'item_group_id']
        const data = this.formatJson(headerVal, list)
        excel.export_json_to_excel({
          header: headerTitle,
          data,
          filename: 'Exportacion para FB',
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
        this.initProgress = false
      })
    },
    clearFields() {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    viewProduct(product) {
      window.open(
        'http://lacamelia.pe/products/' + this.getSlug(product.category.name) + '/' + product.slug,
        '_blank'
      )
    },
    /**
     * Slug
     * @param name
     * @returns {string}
     */
    getSlug(name) {
      let text = (name).trim().split(' ').join('-').toLowerCase().normalize('NFD')
        .replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi, '$1$2')
        .normalize()
      return text
    },
    /**
     * Add data of sidebar
     * */
    addDataSideBar(o) {
      this.list.unshift(o)
    },
    /**
     * Update data of sidebar
     * */
    updateDataSideBar(o) {
      const index = this.list.findIndex((d) => d.id === o.id)
      Object.assign(this.list[index], o)
    },
    /**
     * Export excel to Facebook
     */
    exportToExcelGM() {
      import('@/vendor/Export2Excel').then(async excel => {
        this.initProgress = true
        const list = []
        for await (let p of this.list) {
          let product = {
            id: p.sku,
            title: p.name,
            description: p.description,
            availability: p.state ? 'in_stock' : 'out_of_stock',
            link: 'https://lacamelia.pe/products/' + this.getSlug(p.category.name) + '/' + p.slug,
            image_link: p.image1,
            price: p.priceDiscount + ' PEN',
            identifier_exists: 'no',
            gtin: '',
            mpn: '',
            brand: 'La Camelia'
          }
          list.push(product)
        }
        const headerVal = ['id', 'title', 'description', 'link', 'availability', 'link', 'image_link', 'price', 'identifier_exists', 'gtin', 'mpn', 'brand']
        const headerTitle = ['id', 'title', 'description', 'link', 'availability', 'link', 'image_link', 'price', 'identifier_exists', 'gtin', 'mpn', 'brand']
        const data = this.formatJson(headerVal, list)
        excel.export_json_to_excel({
          header: headerTitle,
          data,
          filename: 'Exportacion para GM',
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.initProgress = false
      })
    },
    /**
     * Save top order
     */
    async saveOrder() {
      try {
        this.initProgress = true
        const batch = db.batch()

        this.list.forEach((product) => {
          const doc = db.collection('products').doc(product.id)
          batch.update(doc, {
            ...product,
            updatedAt: FieldValue.serverTimestamp()
          })
        })

        await batch.commit()

        this.$vs.notify({
          color: 'success',
          title: 'Producto',
          text: 'La modificación fue aplicada.'
        })
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
